const reducer = (state = {}, action) => {
  switch (action.type) {
    case 'SET_EXPENSE_DETAILS': {
      return {
        ...state,
        expenseDetails: action.data,
        showUpdate: action.showUpdate,
        showShimmer: false,
      };
    }
    case 'SET_BILL_ATTACHMENT': {
      return {
        ...state,
        expenseDetails: {
          ...state.expenseDetails,
          transaction: {
            ...state.expenseDetails.transaction,
            bill_urls: action.data.bill_urls,
          },
        },
        showUpdate: false,
      };
    }
    case 'SET_BILL_DESCRIPTION': {
      return {
        ...state,
        expenseDetails: {
          ...state.expenseDetails,
          transaction: {
            ...state.expenseDetails.transaction,
            ...action.data,
          },
        },
        showUpdate: false,
      };
    }
    case 'SET_BILL_ATTACHMENT_DELETE': {
      return {
        ...state,
        expenseDetails: {
          ...state.expenseDetails,
          transaction: {
            ...state.expenseDetails.transaction,
            bill_urls: action.data.transaction.bill_urls,
          },
        },
        showUpdate: true,
      };
    }
    case 'GET_SINGLE_TRANSACTION': {
      return {
        showShimmer: true,
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
